// packages/api-client/queries/factory.ts
// Import all query creators
import { createAuthQueries } from "./auth";
import { createApiKeysQueries } from "./apiKeys";
import { createContestsQueries } from "./contests";
import { createContestsEditionsQueries } from "./contestsEditions";
import { createContestsEditionsJudgesQueries } from "./contestsEditionsJudges";
import { createContestsEditionsStageTableEntriesQueries } from "./contestsEditionsStageTableEntries";
import { createContestsEditionsStageTableJudgesQueries } from "./contestsEditionsStageTableJudges";
import { createContestsEditionLogsQueries } from "./contestsEditionLogs";
import { createContestsEditionsStageTablesQueries } from "./contestsEditionsStageTables";
import { createContestsEditionsStagesQueries } from "./contestsEditionsStages";
import { createContestsEditionsStandingsQueries } from "./contestsEditionsStandings";
import { createContestsEditionsStylesQueries } from "./contestsEditionsStyles";
import { createContestsEditionSurveysQueries } from "./contestsEditionSurveys";
import { createDescriptorsQueries } from "./descriptors";
import { createDescriptorsGroupsQueries } from "./descriptorsGroups";
import { createDiscountCodesQueries } from "./discountCodes";
import { createEntriesQueries } from "./entries";
import { createLeaguesQueries } from "./leagues";
import { createOrganizationsQueries } from "./organizations";
import { createParticipantsQueries } from "./participants";
import { createPaymentProvidersQueries } from "./paymentProviders";
import { createScoresheetCommentsQueries } from "./scoresheetComments";
import { createScoresheetSchemasQueries } from "./scoresheetSchemas";
import { createScoresheetsQueries } from "./scoresheets";
import { createStaffMembersQueries } from "./staffMembers";
import { createStylesQueries } from "./styles";
import { createUserQueries } from "./user";
import { createVersionQueries } from "./version";
import { createJudgesQueries } from "./judges";
import { createTranslationsQueries } from "./translations";
import { createFlawsQueries } from "./flaws";
import { createOrdersQueries } from "./orders";
import { createCertificationStepJudgesQueries } from "./certificationStepJudges";
import { createCertificationStepScoresheetsQueries } from "./certificationStepScoresheets";
import { createCertificationStepsQueries } from "./certificationSteps";
import { createCertificationsQueries } from "./certifications";
import { createContestsEditionJudgeFinalsEntriesQueries } from "./contestsEditionsJudgeFinalsEntries";
import { createJudgingProgrammeJudgesQueries } from "./judgingProgrammeJudges";
import { createJudgingProgrammeQuestionsQueries } from "./judgingProgrammeQuestions";
import { createJudgingProgrammesQueries } from "./judgingProgrammes";
import { createPaymentsQueries } from "./payments";
import { createBreweriesQueries } from "./breweries";
import { createLocalesQueries } from "./locales";
import { createNamespacesQueries } from "./namespaces";
import { createMessagesQueries } from "./messages";
import { createAchievementsQueries } from "./achievements";
import { createUsersAchievementsQueries } from "./usersAchievements";
import { createTiersQueries } from "./tiers";
import { createContactRequestsQueries } from "./contactRequests";
import { createNewsletterSubscriptionsQueries } from "./newsletterSubscriptions";
import { createFlightsQueries } from "./flights";
import { createQAQueries } from "./qa";
export const createQueryFactory = (requests, queryClient) => ({
    auth: createAuthQueries(requests.auth, queryClient),
    apiKeys: createApiKeysQueries(requests.apiKeys),
    achievements: createAchievementsQueries(requests.achievements, queryClient),
    usersAchievements: createUsersAchievementsQueries(requests.usersAchievements, queryClient),
    breweries: createBreweriesQueries(requests.breweries, queryClient),
    contests: createContestsQueries(requests.contests, queryClient),
    contestsEditions: createContestsEditionsQueries(requests.contestsEditions, queryClient),
    contestsEditionsJudges: createContestsEditionsJudgesQueries(requests.contestsEditionsJudges, queryClient),
    contestsEditionsStageTableEntries: createContestsEditionsStageTableEntriesQueries(requests.contestsEditionsStageTableEntries, queryClient),
    contestsEditionsStageTableJudges: createContestsEditionsStageTableJudgesQueries(requests.contestsEditionsStageTableJudges, queryClient),
    contestsEditionLogs: createContestsEditionLogsQueries(requests.contestsEditionLogs, queryClient),
    contestsEditionsStageTables: createContestsEditionsStageTablesQueries(requests.contestsEditionStageTables, queryClient),
    contestsEditionsStages: createContestsEditionsStagesQueries(requests.contestsEditionsStages, queryClient),
    contestsEditionsStandings: createContestsEditionsStandingsQueries(requests.contestsEditionsStandings, queryClient),
    contestsEditionsStyles: createContestsEditionsStylesQueries(requests.contestsEditionsStyles, queryClient),
    contestsEditionSurveys: createContestsEditionSurveysQueries(requests.contestsEditionSurveys, queryClient),
    descriptors: createDescriptorsQueries(requests.descriptors, queryClient),
    descriptorsGroups: createDescriptorsGroupsQueries(requests.descriptorsGroups, queryClient),
    discountCodes: createDiscountCodesQueries(requests.discountCodes, queryClient),
    entries: createEntriesQueries(requests.entries, queryClient),
    leagues: createLeaguesQueries(requests.leagues, queryClient),
    locales: createLocalesQueries(requests.locales, queryClient),
    organizations: createOrganizationsQueries(requests.organizations, queryClient),
    participants: createParticipantsQueries(requests.participants, queryClient),
    paymentProviders: createPaymentProvidersQueries(requests.paymentProviders, queryClient),
    payments: createPaymentsQueries(requests.payments, queryClient),
    scoresheetComments: createScoresheetCommentsQueries(requests.scoresheetComments, queryClient),
    scoresheetSchemas: createScoresheetSchemasQueries(requests.scoresheetSchemas, queryClient),
    scoresheets: createScoresheetsQueries(requests.scoresheets, queryClient),
    staffMembers: createStaffMembersQueries(requests.staffMembers, queryClient),
    styles: createStylesQueries(requests.styles, queryClient),
    tiers: createTiersQueries(requests.tiers, queryClient),
    users: createUserQueries(requests.users, queryClient),
    judges: createJudgesQueries(requests.judges, queryClient),
    version: createVersionQueries(requests.version, queryClient),
    translations: createTranslationsQueries(requests.translations, queryClient),
    flaws: createFlawsQueries(requests.flaws, queryClient),
    orders: createOrdersQueries(requests.orders, queryClient),
    certificationStepJudges: createCertificationStepJudgesQueries(requests.certificationStepJudges, queryClient),
    certificationStepScoresheets: createCertificationStepScoresheetsQueries(requests.certificationStepScoresheets, queryClient),
    certificationSteps: createCertificationStepsQueries(requests.certifications, queryClient),
    certifications: createCertificationsQueries(requests.certificationSteps, queryClient),
    contestsEditionJudgeFinalsEntries: createContestsEditionJudgeFinalsEntriesQueries(requests.contestsEditionJudgeFinalsEntries, queryClient),
    judgingProgrammeJudges: createJudgingProgrammeJudgesQueries(requests.judgingProgrammeJudges, queryClient),
    judgingProgrammeQuestions: createJudgingProgrammeQuestionsQueries(requests.judgingProgrammeQuestions, queryClient),
    judgingProgrammes: createJudgingProgrammesQueries(requests.judgingProgrmmes, queryClient),
    namespaces: createNamespacesQueries(requests.namespaces, queryClient),
    messages: createMessagesQueries(requests.messages, queryClient),
    contactRequests: createContactRequestsQueries(requests.contactRequests),
    newsletterSubscriptions: createNewsletterSubscriptionsQueries(requests.newsletterSubscriptions, queryClient),
    flights: createFlightsQueries(requests.flights),
    qa: createQAQueries(requests.qa),
});
//# sourceMappingURL=index.js.map